module.exports = __webpack_public_path__ + "79952e73ce12de44fb2557b9d3976cf5.svg";


//////////////////
// WEBPACK FOOTER
// ./images/pharmacyIconHover.svg
// module id = 41
// module chunks = 0